const assistant = {
  // Page titles and descriptions
  "causal-assistant-title": "カーザル・アシスタント",
  "causal-assistant-description": "AIを活用した因果推論の支援ツールです。質問に答えるだけで適切な分析手法を提案し、結果の解釈をサポートします。",

  // Tab navigation
  "causal-assistant-tab1": "ホーム",
  "causal-assistant-tab2": "分析",
  "causal-assistant-tab3": "履歴",

  // Welcome section
  "causal-assistant-welcome": "カーザル・アシスタントへようこそ",
  "causal-assistant-welcome-desc": "AIが因果推論をサポートします。どのような分析を行いたいかお聞かせください。",

  // Feature cards
  "causal-assistant-feature1-title": "質問による分析設計",
  "causal-assistant-feature1-desc": "研究の目的や仮説を自然言語で入力すると、適切な因果推論手法を提案します。",
  "causal-assistant-feature1-action": "分析を開始",

  "causal-assistant-feature2-title": "自動グラフ生成",
  "causal-assistant-feature2-desc": "データの特性を分析し、最適なアルゴリズムで因果グラフを自動生成します。",
  "causal-assistant-feature2-action": "グラフ生成",

  "causal-assistant-feature3-title": "結果の解釈支援",
  "causal-assistant-feature3-desc": "分析結果を分かりやすく解説し、実務での活用方法を提案します。",
  "causal-assistant-feature3-action": "解釈を開始",

  // Getting started section
  "causal-assistant-getting-started": "はじめ方",
  "causal-assistant-step1": "1. 研究質問を入力",
  "causal-assistant-step1-desc": "どのような因果関係を調べたいか、自然言語で入力してください。",
  "causal-assistant-step2": "2. データをアップロード",
  "causal-assistant-step2-desc": "分析に使用するデータファイルをアップロードしてください。",
  "causal-assistant-start-now": "今すぐ始める",

  // Chat interface
  "causal-assistant-new-chat": "新しいチャット",
  "causal-assistant-chat-history": "チャット",
  "causal-assistant-welcome-title": "何をお手伝いしましょうか？",
  "causal-assistant-welcome-description": "因果推論や分析についてお気軽にご質問ください",
  "causal-assistant-message-placeholder": "メッセージを入力してください...",
  "causal-assistant-input-help": "因果推論の分析や手法について何でもお聞きください（Enter: 送信、Shift+Enter: 改行）",
  
  // Dropdown menu
  "causal-assistant-rename": "名前を変更する",
  "causal-assistant-delete": "削除する",
  
  // Loading states
  "causal-assistant-loading": "読み込み中...",
  "causal-assistant-history-error": "履歴の読み込みに失敗しました",
  "causal-assistant-no-history": "チャット履歴がありません",
  "causal-assistant-generating": "思考中...",
  "causal-assistant-analyzing": "分析中...",
  "causal-assistant-slow-tool-starting": "分析タスク開始中...",
  "causal-assistant-analysis-tool-running": "分析ツール実行中...",
  "causal-assistant-computing-wait": "計算中です。しばらくお待ちください...",
  
  // Empty chat states
  "causal-assistant-empty-chat-title": "メッセージがありません",
  "causal-assistant-empty-chat-description": "このチャットにはまだメッセージがありません。下のメッセージ入力欄から質問を送信してください。",
  
  // Chat loading states
  "causal-assistant-loading-chat": "チャットを読み込み中...",
  "causal-assistant-loading-chat-description": "メッセージ履歴を取得しています。しばらくお待ちください。",
  
  // Causal Asset selection
  "causal-assistant-causal-asset-loading": "読み込み中...",
  "causal-assistant-causal-asset-select": "コーザルアセットを選択してください",
  "causal-assistant-causal-asset-not-found": "コーザルアセットが見つかりません",
  
  // Analysis results
  "causal-assistant-subgroup-analysis-results": "層別因果分析結果",
  
  // Message editing
  "causal-assistant-edit-message-placeholder": "メッセージを編集...",
  "causal-assistant-cancel": "キャンセル",
  "causal-assistant-send": "送信する",
  "causal-assistant-copy": "コピー",
  
  // Toast messages
  "causal-assistant-toast-rename-success": "チャット名を変更しました",
  "causal-assistant-toast-delete-success": "チャットを削除しました",
  "causal-assistant-toast-rename-error": "チャット名の変更に失敗しました",
  "causal-assistant-toast-delete-error": "チャットの削除に失敗しました",
  "causal-assistant-toast-copy-success": "メッセージをコピーしました",
  "causal-assistant-toast-copy-error": "メッセージのコピーに失敗しました",

  "causal-assistant-task-error-description": "バックグラウンドタスクが失敗しました。もう一度分析を実行してください。",

  // Robustness evaluation
  "causal-assistant-process-result": "処理結果",
  "causal-assistant-robustness-edge": "エッジ",
  "causal-assistant-robustness-ate": "ATE",
  "causal-assistant-robustness-random-cause": "ランダム共通原因",
  "causal-assistant-robustness-data-subset": "データサブセット",
  "causal-assistant-robustness-placebo": "プラセボ処置",
  "causal-assistant-robustness-result-col": "結果",

  // Auto update (autonomous model improvement)
  "causal-assistant-auto-update-result-title": "自律的モデル改善結果",
  "causal-assistant-auto-update-before": "改善前",
  "causal-assistant-auto-update-after": "改善後",

  // Mode
  "causal-assistant-mode-name1": "エキスパートモード",
  "causal-assistant-mode-name2": "ユーザーモード（制限あり）",
  "causal-assistant-mode-name1-request": "エキスパートモード（リクエスト）",

  // Request Modal
  "causal-assistant-request-modal-title": "エキスパートモードのリクエスト",
  "causal-assistant-request-modal-desc": "エキスパートモードを利用できるように管理者にリクエストを送信しますか？",
  "causal-assistant-request-modal-button": "送信",
  "causal-assistant-request-modal-toast-success": "送信しました。",
  "causal-assistant-request-modal-toast-error": "送信に失敗しました。",

  // File upload
  "causal-assistant-attach-file": "ファイルを添付",
  "causal-assistant-remove-file": "削除",
  "causal-assistant-drop-file": "ファイルをドロップ",

  // Candidate sets display
  "causal-assistant-candidate-show-more": "もっと見る +{{n}}件",
  "causal-assistant-candidate-show-less": "閉じる",

  // HITL (Human-in-the-loop)
  "causal-assistant-hitl-title": "因果グラフの変更確認",
  "causal-assistant-hitl-approve": "承認して実行",
  "causal-assistant-hitl-reject": "却下",
  "causal-assistant-hitl-reject-confirm": "却下を確定",
  "causal-assistant-hitl-reject-placeholder": "却下理由（任意）",
  "causal-assistant-hitl-resuming": "承認結果を処理しています...",
  "causal-assistant-hitl-processing": "処理中...",
  "causal-assistant-hitl-input-disabled": "承認待ちのツール実行があります。上の確認から承認または却下してください。",
  "causal-assistant-hitl-toast-error": "承認処理に失敗しました。もう一度お試しください。",

  // Artifact viewer
  "causal-assistant-artifacts-title": "アーティファクト",
  "causal-assistant-artifacts-error": "取得に失敗しました",
  "causal-assistant-artifacts-close": "閉じる",

  // メニュー（ログダウンロード）
  "causal-assistant-menu": "メニュー",
  "causal-assistant-menu-log-download": "ログ・ダウンロード",
  "causal-assistant-log-download-success": "ログをダウンロードしました",
  "causal-assistant-log-download-error": "ログのダウンロードに失敗しました",

  // main 版アシスタント（_legacy）が使用
  "causal-assistant-task-completed-description": "タスクが完了しました。",
  "causal-assistant-show-result-button": "結果を見る",
  "causal-assistant-robustness-result-title": "頑健性評価結果",
};

export default assistant;